export default __webpack_public_path__ + "static/media/noizloader.fd90ce64.mp4";